import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { Quiz } from '@thd-olt-component-react/quiz';
import { useNavigate, useLocation, useParams } from '@thd-olt-component-react/router';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import { SuperSku } from '@thd-olt-component-react/super-sku';
import { HdhomeSignup } from '@thd-olt-component-react/email-signup';

import '../../styles/style-quiz.scss';

export const StyleQuiz = () => {
  const { styleId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Quiz
      styleId={styleId}
      navigate={navigate}
      location={location}
    />
  );
};

StyleQuiz.dataModel = extend(
  Breadcrumbs,
  AddToList,
  SuperSku,
  ProductPod,
  HdhomeSignup,
  Quiz
);
